import React from 'react';
import "./contact.css";
import Motionimg from './../../assets/motion.gif';

const Contact = () => {

  return (
    <section id="contact">
      <h2 className="contactstittle">Contact Me</h2>
      <span className="contactdec">
        Feel free to contact me if you have any questions- 
      </span>
      <div className='motion-img'  data-aos="flip-left"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000" >
        <img src={Motionimg} alt='motion-img' />
      </div>

<div className="contener-icon">
      <div className="contact-details">
        <a href="mailto:abidhasanahnaf01@gmail.com" target="_blank" rel="noreferrer" className="img-link">
          <img src="https://img.icons8.com/color/48/000000/email--v1.png" alt="email" className="contact-img" />
        </a>
        <a href="https://www.linkedin.com/in/abid-hasan-b363b1223/" target="_blank" rel="noreferrer" className="img-link">
            <img src="https://img.icons8.com/color/48/000000/linkedin--v1.png" alt="linkedin" className="contact-img" />
        </a>
         <a href="https://github.com/Abidhasan7-IT" target="_blank" rel="noreferrer" className="img-link">
            <img src="https://img.icons8.com/color/48/000000/github--v1.png" alt="github" className="contact-img" />
        </a>

        </div>
        <div className="contact-detailstwo">

         <a href="https://www.instagram.com/abidhasan494/" target="_blank" rel="noreferrer" className="img-link">
            <img src="https://img.icons8.com/color/48/000000/instagram--v2.png" alt="instagram" className="contact-img" />
        </a>
         <a href="https://twitter.com/AbidHas44458393" target="_blank" rel="noreferrer" className="img-link">
            <img src="https://img.icons8.com/color/48/000000/twitter--v1.png" alt="twitter" className="contact-img" />
        </a>
         <a href="https://www.facebook.com/profile.php?id=100017270292493" target="_blank" rel="noreferrer" className="img-link">
             <img src="https://img.icons8.com/color/48/000000/facebook--v1.png" alt="facebook" className="contact-img" />
         </a>
             
        </div>
        </div>
          
        </section>
  )
}

export default Contact;